import * as z from "zod";
import { requiredString } from "components/form/utils";

export const costMasterSchema = z.object({
  department: requiredString(),
  grade: requiredString(),
  hourly_cost: z.number({ invalid_type_error: "Must be a number" }).positive("Must be greater than 0").optional(),
});
